<template>
	<FeatureDescriptionPreviewTemplate iconName="feature-description-preview">
		<template #description>Appears next to the add-on when it’s visible to the user for the first time</template>
		<template #floating-card>
			<Row class="notification-preview-card">
				<Col class="icon-container mr-4">
					<SIcon name="notification-tab-inbox" width="20" height="20" />
				</Col>
				<Col class="mt-7 flex-justify-space-between">
					<div class="preview-text two-row">{{ onboardingText }}</div>
					<router-link
						target="_blank"
						v-if="workflow?.id"
						:to="toFeatureDetails"
						class="flex-justify-end open-feature-details display-flex flex-align-center"
					>
						Open feature details >>
					</router-link>
				</Col>
			</Row>
		</template>
	</FeatureDescriptionPreviewTemplate>
</template>
<script>
import FeatureDescriptionPreviewTemplate from '@/components/dialogs/OnboardingTextEditorDialog/FeatureDescriptionPreview/FeatureDescriptionPreviewTemplate.vue';
export default {
	name: 'FeatureDescriptionSharingNotificationPreview',
	components: { FeatureDescriptionPreviewTemplate },
	props: {
		workflow: { type: Object },
		onboardingText: { type: String },
	},
	computed: {
		toFeatureDetails() {
			return { name: 'FlowDetails', params: { wfID: this.workflow?.id } };
		},
	},
};
</script>
<style scoped lang="scss">
.notification-preview-card {
	right: 2px;
	width: 238px;
	height: 83px;
	bottom: 100px;
	padding: 6px 8px;
	position: absolute;
	border-radius: 12px;
	background: #ffffff;
	border: 1px solid #e0e5ef;
	box-shadow: 0px 3px 6px #00000029;
}
.preview-text {
	font-size: 10px;
	line-height: 11px;
	letter-spacing: 0px;
	font-weight: normal;
	color: var(--primary-font-color);
}
.open-feature-details {
	font-size: 9px !important;
	color: #5856f9 !important;
	line-height: 11px !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	text-decoration: none !important;
	&:hover {
		text-decoration: underline !important;
	}
}
</style>
